export const CHANGE_LOCATION_PATH = 'CHANGE_LOCATION_PATH';


export const changeLocationPath = ({key, value}) => {
    return async (dispatch) => {
        dispatch({ type: CHANGE_LOCATION_PATH, payload: {key, value}});
    }
};
